import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  withMarginBottom: {
    marginBottom: 20,
  },
}));
